import { __require as Y } from "../utils/common.es.js";
var L, J;
function w() {
  if (J) return L;
  J = 1;
  var U = Y(), S = 15, A = 852, M = 592, R = 0, C = 1, X = 2, K = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], P = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], Q = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], V = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return L = function(h, I, c, g, b, N, t, G) {
    var W = G.bits, r = 0, a = 0, u = 0, f = 0, e = 0, n = 0, i = 0, s = 0, m = 0, v = 0, o, _, x, H, q, B = null, j = 0, E, l = new U.Buf16(S + 1), D = new U.Buf16(S + 1), O = null, z = 0, F, T, d;
    for (r = 0; r <= S; r++)
      l[r] = 0;
    for (a = 0; a < g; a++)
      l[I[c + a]]++;
    for (e = W, f = S; f >= 1 && l[f] === 0; f--)
      ;
    if (e > f && (e = f), f === 0)
      return b[N++] = 1 << 24 | 64 << 16 | 0, b[N++] = 1 << 24 | 64 << 16 | 0, G.bits = 1, 0;
    for (u = 1; u < f && l[u] === 0; u++)
      ;
    for (e < u && (e = u), s = 1, r = 1; r <= S; r++)
      if (s <<= 1, s -= l[r], s < 0)
        return -1;
    if (s > 0 && (h === R || f !== 1))
      return -1;
    for (D[1] = 0, r = 1; r < S; r++)
      D[r + 1] = D[r] + l[r];
    for (a = 0; a < g; a++)
      I[c + a] !== 0 && (t[D[I[c + a]]++] = a);
    if (h === R ? (B = O = t, E = 19) : h === C ? (B = K, j -= 257, O = P, z -= 257, E = 256) : (B = Q, O = V, E = -1), v = 0, a = 0, r = u, q = N, n = e, i = 0, x = -1, m = 1 << e, H = m - 1, h === C && m > A || h === X && m > M)
      return 1;
    for (; ; ) {
      F = r - i, t[a] < E ? (T = 0, d = t[a]) : t[a] > E ? (T = O[z + t[a]], d = B[j + t[a]]) : (T = 96, d = 0), o = 1 << r - i, _ = 1 << n, u = _;
      do
        _ -= o, b[q + (v >> i) + _] = F << 24 | T << 16 | d | 0;
      while (_ !== 0);
      for (o = 1 << r - 1; v & o; )
        o >>= 1;
      if (o !== 0 ? (v &= o - 1, v += o) : v = 0, a++, --l[r] === 0) {
        if (r === f)
          break;
        r = I[c + t[a]];
      }
      if (r > e && (v & H) !== x) {
        for (i === 0 && (i = e), q += u, n = r - i, s = 1 << n; n + i < f && (s -= l[n + i], !(s <= 0)); )
          n++, s <<= 1;
        if (m += 1 << n, h === C && m > A || h === X && m > M)
          return 1;
        x = v & H, b[x] = e << 24 | n << 16 | q - N | 0;
      }
    }
    return v !== 0 && (b[q + v] = r - i << 24 | 64 << 16 | 0), G.bits = e, 0;
  }, L;
}
export {
  w as __require
};
//# sourceMappingURL=inftrees.es.js.map
